import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Image, Paragraph } from '../Components/StyledComponents';
import base64conversion from '../services/base64conversion';
import logo from '../images/icon-192x192.png';

const NoAccessWrapper = () => {
  const history = useHistory();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [logoutErrorMsg, setLogoutErrorMsg] = useState('');
  const studentDetails = JSON.parse(localStorage.getItem('studentDetails'));
  const [isStudentInActive, setIsStudentInActive] = useState(false);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    if (history.location.state) {
      setIsStudentInActive(history.location.state.isStudentInActive);
    }
  }, [history.location.state]);
  useEffect(() => {
    if (!studentDetails) {
      history.push('/');
    }
  }, [studentDetails, history]);

  const handleLogout = () => {
    setIsLoggingOut(true);
    const header = base64conversion();
    const objToBeSent = {
      school_code: studentDetails.school_code,
      student_id: studentDetails.student_id,
      student_no: studentDetails.student_no,
    };

    fetch(`${process.env.REACT_APP_API_HEAD}/digitalidLogout`, {
      method: 'POST',
      body: JSON.stringify(objToBeSent),
      headers: {
        'Content-Type': 'application/json',
        Authorization: header,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 200) {
          localStorage.clear();
          if ('caches' in window) {
            caches.keys().then((names) => {
              names.forEach((name) => {
                caches.delete(name);
              });
            });
          }
          window.location.href = '/';
          setIsLoggingOut(false);
        } else {
          setIsLoggingOut(false);
          setLogoutErrorMsg(res.message);
          setShowToast(true);
          setTimeout(() => setShowToast(false), 3000);
        }
      })
      .catch((error) => {
        if (error) {
          setIsLoggingOut(false);
          setShowToast(true);
          setLogoutErrorMsg('Something went wrong, Please try again!');
          setTimeout(() => setShowToast(false), 3000);
        }
      });
  };

  return (
    <div className="student-inactive-wrapper">
      <div className="logo-wrapper">
        <Image
          alt="School Logo"
          src={studentDetails.school_logo || logo}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = logo;
          }}
          className="school-img"
        />
      </div>
      {isStudentInActive ? (
        <Paragraph className="inactive-msg">
          Digital ID Expired
        </Paragraph>
      ) : (
        <>
          <Paragraph className="inactive-msg">
            No Photo on File
          </Paragraph>
          <Paragraph className="inactive-msg">
            See School Administrator
          </Paragraph>
        </>
      )}
      <button
        type="button"
        className="logout-btn expired-logout"
        tabIndex={0}
        onKeyPress={() => {}}
        onClick={handleLogout}
        disabled={isLoggingOut}
        style={isLoggingOut
          ? { cursor: 'not-allowed' }
          : { cursor: 'pointer' }}
      >
        {isLoggingOut ? (
          <span>
            <i
              className="fa fa-spinner spin"
              aria-hidden="true"
            />
          </span>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <span>
              <i
                className="fa fa-power-off"
                title="Logout"
                aria-hidden="true"
              />
            </span>
            <span style={{ fontSize: '12px' }}>
              Logout
            </span>
          </div>
        )}
      </button>
      {showToast ? (
        <div
          className="logout-error"
          style={{ textAlign: 'center' }}
        >
          <p>{logoutErrorMsg}</p>
        </div>
      ) : null}
    </div>
  );
};

export default NoAccessWrapper;
